import { postUser } from 'utils/queries'
import { Toast } from 'utils/toast'

import { useCurrentUser } from './useCurrentUser'
import { useMutation } from './useMutation'
import { useQueryClient } from './useQueryClient'

export const useBlockUser = (
  userIdToBlock: string | undefined,
  usernameToBlock: string | undefined,
) => {
  const queryClient = useQueryClient()
  const { data: currentUser } = useCurrentUser()

  const blockUser = useMutation(
    async () => {
      if (!currentUser || !userIdToBlock) throw new Error('Error blocking user')

      const blockedUserIds = currentUser.blockedUserIds ?? []
      blockedUserIds.push(userIdToBlock)

      const result = await postUser({
        userId: currentUser.id,
        updatedOrCreatedData: { blockedUserIds },
      })
      return result
    },
    {
      retry: 3,
      onSuccess: () => {
        queryClient.invalidateQueries('posts', { refetchInactive: true })
        queryClient.invalidateQueries('rooms', { refetchInactive: true })
        queryClient.invalidateQueries('user')
        Toast.success(
          `You blocked @${usernameToBlock}.`,
          'You will not longer be able to see any posts or messages from them.',
        )
      },
    },
  )

  return {
    blockUser,
  }
}
